import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { memoGeneric } from '@/js/libs/memo/index.ts';
import { Button } from '../../Controls/Button/index.js';
import { ListItemDescription, ListItemLabel, ListItemWrapper } from './styled.js';
export const ListItem = memoGeneric(function ListItem({ scrollbarWidth, option, onRowAction, disabled: propDisabled, formatOptionLabel, dataTestId, rowActionIcon, }) {
    const disabled = propDisabled || option.disabled;
    const label = useMemo(() => formatOptionLabel?.(option) ?? option.label, [formatOptionLabel, option]);
    const handleActionClick = useCallbackRef(() => {
        onRowAction?.(option);
    });
    return (_jsxs(ListItemWrapper, { disabled: disabled, "data-testid": dataTestId, $scrollbarWidth: scrollbarWidth, children: [_jsxs(ListItemLabel, { disabled: disabled, children: [label, option.description && _jsx(ListItemDescription, { children: option.description })] }), rowActionIcon && !option.fixed && (_jsx(Button, { onClick: handleActionClick, disabled: disabled, ghost: true, dataTestId: `${dataTestId}-button`, children: rowActionIcon }))] }));
});
